import Utils from './utils';

type callbackFn = () => void;

interface iLoader {
    listeners: callbackFn[];
    scriptId: string;
    scriptLoaded: boolean;
}

/**
 * 动态加载脚本
 * @param {string} scriptId
 * @param {Document} doc
 * @param {string} url
 * @param {callbackFn} callback
 */
const injectScriptTag = (scriptId: string, doc: Document, url: string, callback: callbackFn) => {
    const scriptTag = doc.createElement('script');
    scriptTag.type = 'application/javascript';
    scriptTag.id = scriptId;
    scriptTag.addEventListener('load', callback);
    scriptTag.src = url;
    doc.head.appendChild(scriptTag);
};

/**
 * 获取loader配置
 * @returns {iLoader}
 */
export const create = (): iLoader => {
    return {
        listeners: [],
        scriptId: Utils.uuid('fzzf-script'),
        scriptLoaded: false
    };
};

/**
 * 下载方法
 * @param {iLoader} state
 * @param {Document} doc
 * @param {string} url
 * @param {callbackFn} callback
 */
export const load = (state: iLoader, doc: Document, url: string, callback: callbackFn): void => {
    if (state.scriptLoaded) {
        callback();
    } else {
        state.listeners.push(callback);
        if (!doc.getElementById(state.scriptId)) {
            injectScriptTag(state.scriptId, doc, url, () => {
                state.listeners.forEach((fn) => fn());
                state.scriptLoaded = true;
            });
        }
    }
};
